var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6668 25C41.6668 34.2047 34.2049 41.6667 25.0002 41.6667C15.7954 41.6667 8.3335 34.2047 8.3335 25C8.3335 15.7953 15.7954 8.33334 25.0002 8.33334C34.2049 8.33334 41.6668 15.7953 41.6668 25ZM19.9495 19.9494C20.4377 19.4613 21.2292 19.4613 21.7173 19.9494L25.0001 23.2322L28.2829 19.9495C28.771 19.4613 29.5625 19.4613 30.0506 19.9495C30.5388 20.4376 30.5388 21.2291 30.0506 21.7172L26.7679 25L30.0506 28.2827C30.5388 28.7709 30.5388 29.5623 30.0506 30.0505C29.5625 30.5386 28.771 30.5386 28.2828 30.0505L25.0001 26.7678L21.7173 30.0505C21.2292 30.5387 20.4377 30.5387 19.9496 30.0505C19.4614 29.5624 19.4614 28.7709 19.9496 28.2828L23.2323 25L19.9495 21.7172C19.4614 21.229 19.4614 20.4376 19.9495 19.9494Z",
    fill: "#000000",
    stroke: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cbe89006f394731702edecd3c5db1628.svg";
export { ForwardRef as ReactComponent };